import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck, faCalendar, faExternalLinkAlt } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import './LatestSection_Sales.scss';

import { getRateDisplay, getDateStringForSale, hasSaleEnded } from '../../../Helpers/formatting';
import { copyToClipboard } from '../../../Helpers/helpers';
import { getAdjPayoutRate } from '../../../Helpers/user_helpers';

const LatestSection_Sales = props => {
  const { section } = props;
  const { items } = section;
  return (
    <div className='latest-section sales'>
      {items.map(item => (
        <Sale key={item.id} item={item} {...props} />
      ))}
    </div>
  );
};

const Sale = props => {
  const { item, user } = props;
  const { merchant, subtitle, domain, brand } = item;

  // UI Handling
  const [showFullDescription, setShowFullDescription] = React.useState(false);
  const toggleFullDescription = () => setShowFullDescription(!showFullDescription);
  const [isCopyingBadge, setIsCopyingBadge] = React.useState(false);
  const copyBadge = () => {
    setIsCopyingBadge(true);
    copyToClipboard(item.badge);
    setTimeout(() => setIsCopyingBadge(false), 1000);
  };

  // Get Date String
  const dateString = getDateStringForSale(item);
  const rate = getAdjPayoutRate(user, merchant);
  const rateDisplay = getRateDisplay(rate, merchant);
  const hasEnded = hasSaleEnded(item);
  const image = item.image || brand?.mobileCoverImage;
  const url = `https://${domain}`;

  if (!merchant) return null;
  return (
    <div className={cn('sale', { ended: hasEnded })} key={item.id}>
      <div className='percentage'>
        {/* <div className='value'>{rateDisplay || '-'}</div> */}
        {image && <img src={image} alt={merchant.name} />}
      </div>
      <div className='data-container'>
        <div className='main'>
          <div className='title'>{item.title || merchant.name}</div>
          <a href={url} rel='noopener noreferrer' target='_blank' className='merchant'>
            {!hasEnded && rateDisplay && <span className='rate'>Earn {rateDisplay} at </span>}
            <span className='domain'>{domain?.toLowerCase()}</span>
            <FontAwesomeIcon icon={faExternalLinkAlt} className='icon' />
          </a>
          {subtitle && (
            <div
              onClick={toggleFullDescription}
              className={cn('description', {
                expanded: showFullDescription
              })}
            >
              {subtitle}
            </div>
          )}
        </div>
        <div className='date'>
          <FontAwesomeIcon className='icon' icon={faCalendar} />
          {dateString}
        </div>
        {!hasEnded && item.badge && (
          <div className={cn('action-btn', { disabled: hasEnded, copying: isCopyingBadge })} onClick={copyBadge}>
            <div className='display'>{hasEnded ? 'Sale Ended' : isCopyingBadge ? 'Copied' : item.badge}</div>
            {!hasEnded && <FontAwesomeIcon className='icon' icon={isCopyingBadge ? faCheck : faCopy} />}
          </div>
        )}
      </div>
      {props.getItemIndicatorBadges(item, 'primary')}
    </div>
  );
};

LatestSection_Sales.propTypes = {
  section: PropTypes.object.isRequired
};

export default LatestSection_Sales;
